module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan_fukugi-01f4e49a13e92ea1bad07080971b41dc.png";